<template>
    <div>
        <v-img height="200px" :src="image.src" v-if="image.src"></v-img>

        <!-- Fallback: display flower -->
        <div style="width:100%; height:200px; line-height:200px; text-align:center" v-else>
            <v-icon size="100">mdi-flower</v-icon>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ImageCard',
        props: ['refId','type'],
        //data: ()=>({image:{src:''}}),
        computed: {
          image : function(){
              let temp = this.$store.getters.imageList.find( image => image.referenceId==this.refId.uuid)

              if(temp) {
                  return temp;
              }
              return {src:""};
          }
        } ,
        mounted() {
            /*    console.log('load image IN PLANTCARD')
                this.$http.loadImages(this.type, this.refId.uuid)
                    .then(images => {
                        if (images.length)
                            this.image.src = 'https://neos.crellutions.at' + images[0].path + '/' + images[0].filename
                    });
            console.log('load image IN PLANTCARD')*/
            this.$store.dispatch('loadImageNEW', {type:this.type, refId:this.refId.uuid});
        }
    };
</script>

<style scoped>

</style>
